import Hana from '@crehana/compass.icons.outline/Hana';
import Home from '@crehana/compass.icons.outline/Home';

import type { RouteType } from '@/shared/components/DashboardTemplate/types';

import {
  CONFIGURATION,
  GAMIFICATION,
  HANA_AI_ASSISTANT,
  HELP,
  INTEGRATIONS,
  MANAGE,
  MY_SHOP,
  SKILL_XP_EVOLUTION,
  STATISTICS,
  STUDIO_DASHBOARD,
} from './routes';

export const ROUTE_KEY = {
  HOME: 'HOME',
  HANA_AI: 'HANA_AI',
};

export const HOME: RouteType = {
  key: ROUTE_KEY.HOME,
  path: '/org/[slug]/panel/inicio/',
  icon: Home,
  label: 'MENU_ROUTE_HOME',
  nested: [],
};

export const HANA: RouteType = {
  key: ROUTE_KEY.HANA_AI,
  path: '/org/[slug]/panel/hana-ai/',
  icon: Hana,
  label: 'MENU_ROUTE_HANA_AI',
  nested: [],
};

/**
 * For now these modules are the same between admin and Integration panel
 * when a change is required for the Integration as new routes,
 * for example: new features to manage users you need to create a new module
 * instead update the routes.ts file.
 */
export const ROUTES: RouteType[] = [
  STATISTICS,
  MANAGE,
  STUDIO_DASHBOARD,
  SKILL_XP_EVOLUTION,
  GAMIFICATION,
  MY_SHOP,
  INTEGRATIONS,
  CONFIGURATION,
  HANA_AI_ASSISTANT,
];

export const UPPER_ROUTES: RouteType[] = [HOME, HANA];

export const LOWER_MENU_ROUTES: RouteType[] = [HELP];
